import React from 'react';
import PropTypes from 'prop-types';
import css from './progress-bar.scss';

export const Progress = ({ style, width = 0 }) => (
    <div
        className={`${css['progress-wrapper']} ${css[style]}`}
        style={{ minWidth: `${width}px` }}
    />
);

Progress.propTypes = {
    style: PropTypes.string,
    width: PropTypes.number
};

export const generateProgressBar = (chartData) =>
    chartData.map(({ color, width }) => (
        <Progress color={color} width={width} />
    ));



// WEBPACK FOOTER //
// ./components/progress-bar/progress-bar-helpers.js